export default "__VITE_ASSET__CbYGDPxV__"